export default {"src":"/_next/static/media/chevron-down.5de541b0.svg","height":20,"width":20};